<template>
  <section v-if="$route.query.preview !== 'true'">
    <sweet-modal ref="modal" overlay-theme="dark" @close="closeModal">
      <div class="text-left">
        <book-experience-form
          :professional="professional"
          :experience="experience"
          :from="'bookCleanerModal'"/>
      </div>
    </sweet-modal>
    <div class="button-cleaner-booking-modal">
      <div v-if="experience.unavailable_service_area">
        <div class="d-flex justify-content-start align-items-center px-2">
          <div class="flex-fill">
            <span class="text-danger"><i class="fas fa-exclamation-circle"></i> {{ $t('message.experience.unavailable_service_area') }}</span>
          </div> 
          <div>
            <button type="button" class="btn btn-link btn-sm" @click="openUnavailableServiceAreaModal()">
              {{ $t('message.subscription.see_details') }}
            </button>
          </div>   
        </div>
        <hr>
      </div>
      <div class="d-flex justify-content-start align-items-center"
           v-if="Number(experience.service.is_service_request) === 0">
        <div class="px-4">
          <div>
            <span class="price-per-hour">{{ experience.cost | currency }}</span>
            {{ $t('message.experience.starting_at') }}
          </div>
        </div>
        <div class="flex-fill flex-grow-1 pr-4">
          <button class="btn btn-info btn-block btn-lg"
                  :disabled="(experience.active === 0 || professional.active === 0)"
                  data-toggle="modal"
                  data-target="#bookCleanerModal"
                  @click="openModal">
            {{ $t('message.button.book') }}
          </button>
        </div>
      </div>
      <div class="px-4" v-else>
        <router-link
          :to="{path: '/service-requests/booking', query: { service_id: experience.service.id, experience_id: experience.id }}"
          class="btn btn-info btn-block btn-lg">
          {{ $t('message.experience.evaluate') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import BookExperienceForm from './BookExperienceForm'

  export default {
    props: ['professional', 'experience'],
    components: {
      BookExperienceForm,
      SweetModal
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      openUnavailableServiceAreaModal () {
        this.$parent.openUnavailableServiceAreaModal()
      },
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      },
      openLoginModal () {
        const parent = this.$parent
        parent.$parent.openModal('login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/experience/components/BookExperienceModal.vue